import { Icons } from '~/assets/fonts/Icons/icons';

export enum ORDERING_CHANNELS {
  WEBSITE = 0,
  IOS_APP = 2,
  ANDROID_APP = 3,
  CALL_CENTRE = 4,
  KIOSK = 5,
  E_MENU = 6,
  JAHEZ = 7,
  CAREEM = 8,
  DOOK = 9,
  // EXTERNAL_DOOK = 10,
  MINI_DOOK = 11,
  HUNGER_STATION = 12,
  TO_YOU = 13,
  KEETA = 14,
}

export const orderingChannelsIcons: Record<ORDERING_CHANNELS, Icons> = {
  [ORDERING_CHANNELS.WEBSITE]: Icons.Globe,
  [ORDERING_CHANNELS.IOS_APP]: Icons.Apple,
  [ORDERING_CHANNELS.ANDROID_APP]: Icons.Android,
  [ORDERING_CHANNELS.CALL_CENTRE]: Icons.CallCenter,
  [ORDERING_CHANNELS.KIOSK]: Icons.Kiosk,
  [ORDERING_CHANNELS.E_MENU]: Icons.QrCode,
  [ORDERING_CHANNELS.JAHEZ]: Icons.IcJahez,
  [ORDERING_CHANNELS.CAREEM]: Icons.IcCareem,
  [ORDERING_CHANNELS.DOOK]: Icons.IcDook,
  [ORDERING_CHANNELS.MINI_DOOK]: Icons.IcMiniDook,
  [ORDERING_CHANNELS.HUNGER_STATION]: Icons.IcHungerStation,
  [ORDERING_CHANNELS.TO_YOU]: Icons.IcToYou,
  [ORDERING_CHANNELS.KEETA]: Icons.IcKeeta,
};

export const orderingChannelsLangKeys: Record<ORDERING_CHANNELS, string> = {
  [ORDERING_CHANNELS.WEBSITE]: 'website',
  [ORDERING_CHANNELS.IOS_APP]: 'ios_app',
  [ORDERING_CHANNELS.ANDROID_APP]: 'android_app',
  [ORDERING_CHANNELS.CALL_CENTRE]: 'call_centre',
  [ORDERING_CHANNELS.KIOSK]: 'kiosk',
  [ORDERING_CHANNELS.E_MENU]: 'e_menu',
  [ORDERING_CHANNELS.JAHEZ]: 'Jahez',
  [ORDERING_CHANNELS.CAREEM]: 'Careem',
  [ORDERING_CHANNELS.DOOK]: 'dook',
  [ORDERING_CHANNELS.MINI_DOOK]: 'mini_aggregator',
  [ORDERING_CHANNELS.HUNGER_STATION]: 'HungerStation',
  [ORDERING_CHANNELS.TO_YOU]: 'ToYou',
  [ORDERING_CHANNELS.KEETA]: 'Keeta',
};
